/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Accounts mock Client
 */

// TODO : remove later
export default class AccountsAddOnsInfoApi {
	constructor(...args: AnyType) {
		return args;
	}
	getAddOns = (): AnyType => Promise.resolve({ data: [] });
}
